import { createSelector } from 'reselect';

export const r2rAccountOptions = ({ administration }) => (
  administration.chartOfAccounts.r2rAccountValues
);

export const importStatusOptionsSelector = createSelector(
  ({ administration }) => administration.chartOfAccounts.importStatusValues,
  importStatusValues => importStatusValues.map(({
    longName,
    statusID,
  }) => ({
    label: longName,
    value: statusID,
  }))
);

export const selectFetchChartAccountsErrorSelector = ({ administration }) =>
  administration.chartOfAccounts.fetchChartAccountsError;

export const selectFetchChartAccountsLoadingSelector = ({ administration }) =>
  administration.chartOfAccounts.chartAccountsLoading
  || administration.chartOfAccounts.chartAccountsImporting;

export const isDeletingChartInProgressSelector = ({ administration }) =>
  administration.chartOfAccounts.isDeletingChartInProgress;

export const isRemovingChartAccountInProgressSelector = ({ administration }) =>
  administration.chartOfAccounts.isRemovingChartAccountInProgress;

export const isFetchingInitialDataForAddAndEditChartAccountModalSelector = ({ administration }) =>
  administration.chartOfAccounts.isFetchingInitialDataForAddAndEditChartAccountModal;

export const isSavingChartInProgressSelector = ({ administration }) =>
  administration.chartOfAccounts.isSavingChartInProgress;
